import { handleModalKeydown, isMobile, selfInstantiateOnLoad } from "../utils";
const doWindow = window;
export function buildAdditionalLeadData(trigger, form) {
    const path = trigger?.dataset?.specialDetailsUri ?? "";
    const commentAddition = trigger?.dataset?.commentAddition ?? "";
    const coupon = trigger?.dataset?.coupon ?? "";
    const optOutField = form["DoNotSellPersonalInfo"];
    const additionalFields = form.querySelectorAll("[data-additional-field]");
    const comments = [];
    for (const field of additionalFields) {
        const name = field.getAttribute("data-additional-field");
        const value = field.value;
        comments.push(`${name}: ${value}`);
    }
    if (coupon) {
        comments.push(`Coupon: ${coupon}`);
    }
    if (commentAddition) {
        comments.push(`${commentAddition}, SMS: yes, URL: ${globalThis.location.href}`);
    }
    if (optOutField) {
        comments.push(`Do Not Sell Personal Info: ${optOutField.checked}`);
    }
    return {
        MessageLink: path,
        Comments: comments.join("; "),
    };
}
export default class SmsFormModal {
    constructor() {
        this._trigger = null;
        this.initialize = () => {
            const triggers = document.querySelectorAll(".sms-lead-modal");
            for (const trigger of triggers) {
                trigger.addEventListener("click", this.openModal);
            }
            const closeBtn = this._modal.querySelector("button");
            closeBtn.addEventListener("click", this.closeModal);
            const toggleBtn = document.getElementById("toggleLeadPortion");
            toggleBtn.addEventListener("change", this.toggleLeadPortion);
            const leadSubmissionOptions = {
                leadSource: (form) => Number(form["LeadSource"].value ?? 0),
                leadType: (form) => Number(form["LeadType"].value ?? 0),
                additionalData: this.getAdditionalLeadData,
                successCallback: (data) => {
                    let lid = -1;
                    try {
                        const parsed = JSON.parse(data);
                        if (parsed.leadId && !isNaN(parsed.leadId)) {
                            lid = parsed.leadId;
                        }
                    }
                    catch (err) {
                        console.warn("Error parsing lead response to JSON.", err);
                    }
                    if (lid !== -1) {
                        window.location.href = `/thankyou.aspx?lid=${lid}`;
                    }
                    else {
                        doWindow.DealeronLead.token.value = null;
                        this._form["Submit"].removeAttribute("disabled");
                        this.closeModal();
                    }
                },
                errorCallback: (request, status, error) => {
                    alert("An error occurred sending the message. Please try again.");
                    console.error("Lead submission error", { status, error });
                    this._form["Submit"].removeAttribute("disabled");
                },
                endpoint: "/api/lead/sms/#TOKEN#",
            };
            doWindow.DealeronLead.addSubmissionMethod("smsLeadFormSubmit", leadSubmissionOptions);
            doWindow.DealeronLead.initialize("#smsLeadForm", "smsLeadFormSubmit");
        };
        this.openModal = (e) => {
            e.preventDefault();
            this._trigger = e.currentTarget;
            const leadSource = this.getLeadSource();
            const leadType = this.getLeadType();
            this._form["LeadSource"].value = leadSource;
            this._form["LeadType"].value = leadType;
            const phoneField = this._form["Phone"];
            phoneField?.addEventListener("focus", doWindow.DealeronLead.begin, {
                once: true,
            });
            this._modal.addEventListener("keydown", this.handleModalKeys);
            this._modal.removeAttribute("hidden");
            this._modal.focus();
        };
        this.getLeadSource = () => {
            return this._isMobile
                ? this._trigger?.getAttribute("data-lead-source-mobile") ?? "0"
                : this._trigger?.getAttribute("data-lead-source-desktop") ?? "0";
        };
        this.getLeadType = () => {
            return this._trigger?.getAttribute("data-lead-type") ?? "0";
        };
        this.closeModal = () => {
            // this._modal.setAttribute("hidden", "true");
            this._modal.style.display = "none";
            this._modal.hidden = true;
            doWindow.jQuery("#smsLeadModal").modal("hide");
            this._modal.removeEventListener("keydown", this.handleModalKeys);
            if (this._trigger) {
                this._trigger.focus();
                this._trigger = null;
            }
            this.clearForm();
            const phoneField = this._form["Phone"];
            phoneField?.removeEventListener("focus", doWindow.DealeronLead.begin);
        };
        this.clearForm = () => {
            const fields = this._form.querySelectorAll("#smslead_phone, #leadPortion input, #leadPortion select");
            for (const field of fields) {
                field.value = "";
            }
        };
        this.handleModalKeys = (e) => {
            const buttons = this._modal.querySelectorAll("button");
            const first = buttons[0];
            const last = buttons[buttons.length - 1];
            handleModalKeydown(e, first, last, this.closeModal);
        };
        this.toggleLeadPortion = (e) => {
            const toggle = e.currentTarget;
            const leadPortion = document.getElementById("leadPortion");
            if (toggle.checked) {
                leadPortion.removeAttribute("disabled");
                leadPortion.removeAttribute("hidden");
            }
            else {
                leadPortion.setAttribute("hidden", "true");
                leadPortion.setAttribute("disabled", "true");
            }
        };
        this.getAdditionalLeadData = () => buildAdditionalLeadData(this._trigger, this._form);
        this._modal = document.getElementById("smsLeadModal");
        if (!this._modal) {
            console.warn("SmsformModal script loaded but smsLeadModal element not found.");
            return;
        }
        this._form = this._modal.querySelector("form");
        this._isMobile = isMobile();
        this.initialize();
    }
}
selfInstantiateOnLoad(SmsFormModal);
